import React from 'react';

import { getPaymentResult } from 'models/receiptForm';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/result',
	components: () => [import(/* webpackChunkName: 'event' */ './component')],
	render: ([Result]) => <Result />,
	onEnter: async ({ store, history }) => {
		console.log('on Enter Payment result');

		const { login } = store.getState();
		const [isExpired, isNotGrMember] = [login.isGrMember.expired, !login.isGrMember.isMember];

		// token 過期 or 非會員 皆無法進入會員頁
		if (isExpired || isNotGrMember) {
			history.replace('/');
		}

		await store.dispatch(getPaymentResult());

		console.log('on Enter Payment result / end');
	},
};

export default routes;
